import { Button, CheckedImage, Input } from "common/commonIndex";
import React, { useEffect, useState } from "react";
import { AddressInformation, InsuranceCardInfo } from "../questionnaireIndex";
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";
import CommonService from '../../../services/API/commonService';

const NestedQuestion = ({ handleNextEvent, formData, step, questionData }) => {
    const [inputValue, setInputValue] = useState('');
    const [states, setStates] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const { state: data, dispatch } = useAuthenticationContext();
    const [nestedAnswer, setNestedAnswer] = useState({
        questionId: null,
        answer: null,
        answerId: null,
        questionerType: null,
        userIdDocument: null,
        none: null,
        question: null,
    });
    const [validField, setValidField] = useState({
        street: false,
        city: false,
        state: true,
        zip: false,
    });
    const [validFields, setValidFields] = useState({
        id: false,
        group: false,
        bin: false,
        pcn: false,
    });


    useEffect(() => {
        let findStates = JSON.parse(localStorage.getItem('stateList'));
        if(findStates?.length > 0){
            setStates(findStates);
        }else{
            getDemographicsState();
        }
        
        handleSetData();
    }, []);

    const getDemographicsState = async () => {
        try {
            const accessToken = data?.userData?.result?.token;
            
            const response = await CommonService.getDemographicsState(accessToken);
            if (response?.statusCode === 200) {
                setStates(response?.result);
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        } finally {
        }
    }

    const handleSubmit = () => {
        let skip = 1;
        // if(questionData?.skippedNestedQuestionID){
        //     skip = 2;
        // }
        if (questionData.questionType === 15) {
            const findState = formData?.answer.find(x => x?.question?.toLowerCase() === 'state');
            if (!findState) {
                formData?.answer?.push({
                    fkQuestionId: 5646, // Replace with the relevant ID if needed
                    answer: 'Alabama',
                    fkAnswerIds: 'Alabama',
                    questionerType: 152, // Replace with the relevant type if needed
                    question: 'State',
                });
            }
        }
        const findData = getLocalStorageData();
        findData[questionData.questionerIndex] = formData;
        setLocalStorageData(findData);
        handleNextEvent(questionData?.questionerIndex + skip);
    }
    const getLocalStorageData = () => {
        const findlocalStorageData = JSON.parse(localStorage.getItem('listOfAnswer'));
        return findlocalStorageData;
    }
    const setLocalStorageData = (data) => {
        if (data?.length > 0) {
            localStorage.setItem('listOfAnswer', JSON.stringify(data));
        }
    }
    const handleSetData = (data, validFields) => {
        if (formData) { }
        const allValid = formData?.answer?.filter(x => x.answer === '' || !x.answer)?.length === 0;;
        if (allValid) {
            setIsDisabled(allValid);
            console.log("All fields are valid!");
        } else {
            setIsDisabled(allValid);
            console.log("Some fields are invalid.");
        }
    }

    const checkValidation = () => {
        if (questionData.questionType === 15) { 
            return Object.values(validField).every((isValid) => isValid);
        }else{
            return Object.values(validFields).every((isValid) => isValid);
        }
    }


    return (
        <>
            <h3 className="title">{questionData?.question}</h3>
            <>
                <div className="eligibility questionnaire insurance-card form-input-label">
                    {questionData?.nestedQuestions?.map((nestedQuestion, index) =>
                        questionData.questionType === 15 ? (
                            <AddressInformation nestedQuestion={nestedQuestion} formData={formData} nestedAnswer={nestedAnswer} handleSetData={handleSetData} states={states} setIsValid={setIsValid} setValidField={setValidField} />
                        ) : (
                            <InsuranceCardInfo nestedQuestion={nestedQuestion} formData={formData} nestedAnswer={nestedAnswer} handleSetData={handleSetData} setIsValid={setIsValid} validFields={validFields} setValidFields={setValidFields} />
                        )
                    )}
                </div>
                <div className="questionnaire-fix-btn eligibility-fix-btn">
                    <div className="divider "></div>
                    <div className="footer-content">
                        <div className="skip-eligibility">
                        </div>
                        <Button
                            btnClass={'btn-primary question-btn'}
                            btnType={'button'}
                            btnName={'Continue'}
                            onClick={handleSubmit}
                            isDisabled={checkValidation()}
                        />
                    </div>
                </div>
            </>
        </>
    )
}

export default NestedQuestion;